import React, { useState } from "react";
import ServerErrorModal from "../../../organisms/ServerErrorModal";
import { Button, Col, Row, ListGroup, Badge } from "react-bootstrap";
import styled from "styled-components";
import { HeaderSection } from "../HeaderSection";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Title } from "../Title";

import { Model } from "../Model";
import { currencyFormat } from "../../../../utils/numberUtils";
import Fechas from "../Fechas/Fechas";
import {
  ItemListadoServiciosSpa,
  useListarServiciosSpa,
} from "../../../../services/spaServicios";
import SuccessButton from "../../../organisms/SuccessButton";
import { useWizard } from "../../../../hooks/wizard";
import SeleccionMascota from "../SeleccionMascota/SeleccionMascota";

function Tarifas({ model }: { model: Model }) {
  const [currentModel, setCurrentModel] = useState(model);
  const { avanza, vuelve, volver, avanzar } = useWizard();

  const {
    data: tarifas,
    isLoading: tarifasIsLoading,
    isError: tarifasIsError,
  } = useListarServiciosSpa();

  const onTarifaClick = (tarifa: ItemListadoServiciosSpa) => {
    setCurrentModel((prevModel) => {
      return {
        ...prevModel,
        tarifa: tarifa,
        valorFinalTarifa: tarifa.precioSesion,
      };
    });
  };

  const onMananaClick = () => {
    setCurrentModel((prevModel) => {
      return {
        ...prevModel,
        horario: "MANANA",
      };
    });
  };

  const onTardeClick = () => {
    setCurrentModel((prevModel) => {
      return {
        ...prevModel,
        horario: "TARDE",
      };
    });
  };

  const puedeAvanzar = !!currentModel.tarifa && currentModel.horario;

  if (tarifasIsError) {
    return <ServerErrorModal />;
  }

  if (avanza) {
    return <Fechas model={currentModel} />;
  }

  if (vuelve) {
    return <SeleccionMascota model={currentModel} />;
  }

  return (
    <Row className="justify-content-center">
      <Col className="col-10">
        <HeaderSection className="pt-2 pb-2">
          <Title>
            Datos de agendamiento
            <IconContainer>
              <CalendarMonthIcon sx={{ fontSize: 28 }} />
            </IconContainer>
          </Title>
        </HeaderSection>
        <Row>
          <Row className="mb-3 w-50">
            <label className="mb-2">Horario:</label>
            <div
              className="btn-group"
              role="group"
              aria-label="Basic checkbox toggle button group"
            >
              <input
                type="checkbox"
                className="btn-check"
                id="btn_check_manana"
                checked={currentModel.horario === "MANANA"}
                onClick={onMananaClick}
              />
              <label
                className="btn btn-outline-primary"
                htmlFor="btn_check_manana"
              >
                Mañana
              </label>

              <input
                type="checkbox"
                className="btn-check"
                id="btn_check_tarde"
                checked={currentModel.horario === "TARDE"}
                onClick={onTardeClick}
              />
              <label
                className="btn btn-outline-primary"
                htmlFor="btn_check_tarde"
              >
                Tarde
              </label>
            </div>
          </Row>
          <Row className="mb-4">
            <div className="mb-2">Seleccione tarifa:</div>
            {tarifasIsLoading && (
              <div>
                <i>Cargando tarifas...</i>
              </div>
            )}
            {!tarifasIsLoading && !!tarifas && (
              <div>
                <ListGroup as="ul">
                  {tarifas.map((tarifa) => (
                    <StyledListGroupItem
                      action
                      onClick={() => {
                        onTarifaClick(tarifa);
                      }}
                      className="d-flex justify-content-between align-items-start"
                      active={tarifa.id === currentModel.tarifa?.id}
                      key={tarifa.id}
                    >
                      <div className="ms-2 me-auto">
                        <div className="fw-bold">{tarifa.nombre}</div>
                        <div>{tarifa.descripcion}</div>
                      </div>
                      <div className="ms-2 me-auto"></div>
                      <Badge bg="success" pill>
                        {currencyFormat(tarifa.precioSesion)}
                      </Badge>
                    </StyledListGroupItem>
                  ))}
                </ListGroup>
              </div>
            )}
          </Row>

          <Row className="mb-2">
            <Col className="d-flex justify-content-between">
              <Button
                type={"button"}
                style={{ width: "fit-content" }}
                onClick={volver}
              >
                <ArrowBackIcon sx={{ fontSize: 20 }} />
                Volver
              </Button>
              <SuccessButton
                type={"button"}
                style={{ width: "fit-content" }}
                disabled={!puedeAvanzar}
                onClick={avanzar}
              >
                Siguiente <ArrowForwardIcon sx={{ fontSize: 20 }} />
              </SuccessButton>
            </Col>
          </Row>
        </Row>
      </Col>
    </Row>
  );
}

const StyledListGroupItem = styled(ListGroup.Item)`
  &.active {
    z-index: 2;
    background-color: ${(props) => props.theme.colors.mainShadow};
    border-color: ${(props) => props.theme.colors.main};
    color: #212529;
  }
`;

const IconContainer = styled("span")`
  display: relative;
  margin-left: 8px;
  color: ${(props) => props.theme.colors.main};
`;

export default Tarifas;
